import React from "react";
import {useTranslation} from "react-i18next";

import MDInput from "materialDashboard/components/MDInput";
import MDAvatar from "materialDashboard/components/MDAvatar";
import MDBox from "materialDashboard/components/MDBox";
import Stack from "@mui/material/Stack";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";


const NameSection = ({formik, workgroup}) => {
    const {t} = useTranslation(['workgroups', 'enums']);
    const name = formik.values.name ?? "";
    const initials = name ? name.split(/[,' ]/).map((n) => n[0]).join("") : "";

    const showPropagateVisibilityCheckbox = workgroup?.visibility !== formik.values.visibility;

    return <Stack spacing={5} sx={{width: "100%"}}>
        <MDBox sx={{display: "flex", alignItems: "center", justifyContent: "center"}}>
            <MDAvatar src={workgroup?.logo?.path} name={name} sx={{width: "150px", height: "150px"}} bgColor={"secondary"}>
                {initials}
            </MDAvatar>
        </MDBox>

        <MDInput name="name"
                 label={t('workgroupForm.name')}
                 value={formik.values.name}
                 onChange={formik.handleChange}
                 error={formik.touched.name && Boolean(formik.errors.name)}
                 helperText={formik.touched.name && formik.errors.name}
                 variant="standard"
                 fullWidth
        />

        <MDInput name="visibility"
                 label={t('workgroupForm.visibility')}
                 value={formik.values.visibility}
                 onChange={formik.handleChange}
                 error={formik.touched.visibility && Boolean(formik.errors.visibility)}
                 helperText={formik.touched.visibility && formik.errors.visibility}
                 variant="standard"
                 fullWidth
                 select>
            {
                ["PUBLIC", "PRIVATE", "SHARED"].map(option => (
                    <MenuItem key={option} value={option}>
                        {t('enums:workgroupVisibility.' + option)}
                    </MenuItem>
                ))
            }
        </MDInput>

        {showPropagateVisibilityCheckbox &&
            <FormControlLabel control={<Checkbox checked={formik.values.propagate_visibility}
                                                 onChange={formik.handleChange}
                                                 name='propagate_visibility'
                                                 color="info"
                                                 inputProps={{'aria-label': 'controlled'}}
                                                 size="small"/>}
                              label={t('workgroupForm.propagateVisibility')}/>}
    </Stack>
}

export default NameSection;